import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { formatTime, liveText } from '../../domain/countdown-bar.helpers';
import type { CountdownBarItem } from '../../store/countdown-bar.store';

@Component({
  selector: 'bingo-countdown-bar-time',
  templateUrl: './countdown-bar-time.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CountdownBarTimeComponent {
  protected readonly liveText = liveText;
  protected readonly formatTime = formatTime;
  readonly item = input.required<CountdownBarItem>();
}
